import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressButtonComponent } from './progressbutton.component';
/**
 * NgModule definition for the ProgressButton component.
 */
export class ProgressButtonModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        ProgressButtonComponent
    ],
    exports: [
        ProgressButtonComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ProgressButtonModule_tsickle_Closure_declarations() {
/** @type {?} */
ProgressButtonModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProgressButtonModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
